import _ from "lodash";

import { getIconKind } from "Datasets/modules/Utils";
import { EMPTY_CELL } from "../constants";

// Attachment.metadata stores emoji.native in `title`, so glyph = attachment.title.
const attachmentToIconPickerValue = attachment => {
  if (!attachment) return null;
  const { isEmoji, isIcon, isImage } = getIconKind(attachment);

  if (isEmoji) {
    return { type: "emoji", glyph: attachment.title || "" };
  }
  if (isIcon) {
    return {
      type: "icon",
      name: attachment.title || attachment.metadata?.iconName || "",
      color: attachment.metadata?.colorVariable || undefined,
    };
  }
  if (isImage) {
    return { type: "image", src: attachment.url || "" };
  }
  return null;
};

const getIconPickerCellProps = ({ node, cellConfig, customConfig }) => {
  const { property, showEmptyCellAsFallback } = customConfig || {};
  const { styles } = cellConfig;
  const attachment = _.get(node, property);

  const value = attachmentToIconPickerValue(attachment);
  if (!value && showEmptyCellAsFallback) return { ...EMPTY_CELL, styles };
  return {
    ...cellConfig,
    value,
  };
};

export default getIconPickerCellProps;
